import { render } from "./TvmFullFillmentText.vue?vue&type=template&id=a5c4a744&scoped=true"
import script from "./TvmFullFillmentText.js?vue&type=script&lang=js&external"
export * from "./TvmFullFillmentText.js?vue&type=script&lang=js&external"

import "./TvmFullFillmentText.vue?vue&type=style&index=0&id=a5c4a744&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5c4a744"],['__file',"src/components/ChatWidget/TvmFullFillmentText/TvmFullFillmentText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5c4a744"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5c4a744', __exports__)) {
    api.reload('a5c4a744', __exports__)
  }
  
  module.hot.accept("./TvmFullFillmentText.vue?vue&type=template&id=a5c4a744&scoped=true", () => {
    api.rerender('a5c4a744', render)
  })

}


export default __exports__